"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteUserTopic = void 0;
var Topic_1 = require("../Topic");
var SiteUserTopic = /** @class */ (function (_super) {
    __extends(SiteUserTopic, _super);
    function SiteUserTopic(allowedSuffixes) {
        var _this = _super.call(this, allowedSuffixes.map(function (suffix) { return "siteuser/+/+/".concat(suffix); })) || this;
        _this.allowedSuffixes = allowedSuffixes;
        return _this;
    }
    SiteUserTopic.prototype.buildTopics = function (_a) {
        var _b = _a.userUuid, userUuid = _b === void 0 ? "all" : _b, _c = _a.siteUuid, siteUuid = _c === void 0 ? "unknown" : _c;
        return this.allowedSuffixes.map(function (suffix) { return "siteuser/".concat(siteUuid.toLowerCase(), "/").concat(userUuid.toLowerCase(), "/").concat(suffix); });
    };
    return SiteUserTopic;
}(Topic_1.Topic));
exports.SiteUserTopic = SiteUserTopic;
//# sourceMappingURL=SiteUserTopic.js.map